import { createContext } from 'react';
import type { SipPhone } from './useSipPhone';

/**
 * Общий телефон оператора — контекст отдельно от компонента-провайдера.
 *
 * Разделение не украшение: в файле с компонентами держать что-то, кроме
 * компонентов, нельзя — иначе ломается горячая перезагрузка при разработке.
 */
export interface PhoneContextValue {
  phone: SipPhone;
  /** Идёт подключение — кнопка ждёт. */
  connecting: boolean;
  connectError: string | null;
  connect: () => Promise<void>;
  /** Номер текущего (или последнего) разговора — переживает переход между экранами. */
  activeNumber: string | null;
  /** Local UI intent only; it is never a backend call/source ID. */
  dialRevision?: number;
  /**
   * Набрать номер (§2.19, §10a «Позвонить» из журнала).
   *
   * Живёт здесь, а не в кабинете: звонить умеет тот, кто держит соединение,
   * и с любого экрана номер набирается одним и тем же способом.
   */
  dial: (phone: string) => void;
  /**
   * `s726`: телефон этого человека держит другое окно этого же браузера. Здесь его
   * подключать не нужно — и «не подключён» было бы неправдой.
   */
  vDrugomOkne?: boolean;
  /**
   * `s726`: «Позвонить» из карточки лида или записи. Звонок начинает станция: с линии филиала
   * клиентки, с точной привязкой исхода к этой карточке; номер в браузер не уходит.
   * Возвращает слова отказа либо null.
   */
  pozvonitIzKartochki?: (obyekt: { inquiry_id?: number; booking_id?: number }) => Promise<string | null>;
  /** `s726`: набор номера с выбранной линии станцией; строка — отказ словами, null — начат. */
  nabratSLinii?: (number: string, lineId: number) => Promise<string | null>;
}

export const PhoneContext = createContext<PhoneContextValue | null>(null);
